import "./tab3.scss";
import {useState} from "react";
import SettingCard, {ISettingCard} from "../../../../../ui/settingcard/settingcard";
import * as React from "react";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import {autoCompleteItem} from "../../../../../modals/types/autocomplete";
import AutoComplete from "../../../../../ui/autocomplete/autocomplete";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import DropDown from "../../../../../ui/dropdown/dropdown";

const Tab3 = () => {
    const [activate, setActivate] = useState("setting0");
    const settingItems: ISettingCard[] = [
        {
            title: "تنظیمات پیش فرض",
            body: "تنظیمات را تیجار برای شما انتخاب می کند.",
            id: 0,
            activate: activate,
            setActivate: setActivate
        },
        {
            title: "تنظیمات دلخواه جزییات",
            body: "تنظیمات را به صورت دستی انتخاب می کنید.",
            id: 1,
            activate: activate,
            setActivate: setActivate
        }
    ]
    const utmMediumDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const utmContentDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const utmCampaignDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const utmTermDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const utmSourceDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const settingContent: JSX.Element[] = [
        <>
            <div>1</div>
        </>,
        <>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">utm - medium</label>
                <DropDown items={utmMediumDropDownItems} placeHolder={"انتخاب کنید"}/>
            </div>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">utm - content</label>
                <DropDown items={utmContentDropDownItems} placeHolder={"نام نمایش دهنده"}/>
            </div>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">utm - campaign</label>
                <DropDown items={utmCampaignDropDownItems} placeHolder={"انتخاب کنید"}/>
            </div>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">utm - term</label>
                <DropDown items={utmTermDropDownItems} placeHolder={"شماره تبلیغ همسان"}/>
            </div>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">utm - source</label>
                <DropDown items={utmSourceDropDownItems} placeHolder={"teejar"}/>
            </div>
        </>,
    ]
    return(
        <div className="Tab3">
            <h5>مدیریت utm ها</h5>
            <div className="row pt-3">
                {
                    settingItems.map((settingItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={activate} title={settingItem.title} body={settingItem.body}
                                             setActivate={setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <HorizontalDivider />
            <div className="row mt-4 py-3">
                {settingContent[parseInt(activate.substring(7, 8))]}
            </div>
            <HorizontalDivider />
        </div>
    );
}

export default Tab3;